import Offers from "./Offers";

export { Offers as default };
